import React from 'react';
import { AdComponent } from './AdComponent';

interface SidebarAdProps {
  /** Additional CSS classes */
  className?: string;
  /** Whether to make the ad sticky */
  sticky?: boolean;
}

/**
 * Ad component for sidebar placement on report detail pages
 * Designed to fit in the right sidebar below location details
 */
export const SidebarAd: React.FC<SidebarAdProps> = ({
  className = '',
  sticky = false
}) => {
  return (
    <div className={`sidebar-ad ${sticky ? 'sticky top-6' : ''} ${className}`}>
      <AdComponent
        format="vertical"
        responsive={true}
        className="sidebar-ad-content"
        fallback={
          // Fallback content that matches sidebar styling
          <div className="bg-white rounded-2xl p-6 shadow-card border border-gray-100">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-cardboard-100 to-cardboard-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🏪</span>
              </div>
              <h3 className="font-semibold text-urban mb-2">
                Local Business Directory
              </h3>
              <p className="text-sm text-urban-400 mb-4">
                Discover amazing local businesses and services in your area
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-urban-400">
                  <span className="w-2 h-2 bg-verge rounded-full"></span>
                  <span>Restaurants & Cafes</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-urban-400">
                  <span className="w-2 h-2 bg-treasure rounded-full"></span>
                  <span>Home Services</span>
                </div>
                <div className="flex items-center gap-2 text-xs text-urban-400">
                  <span className="w-2 h-2 bg-cardboard rounded-full"></span>
                  <span>Retail & Shopping</span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <span className="text-xs text-urban-300">Sponsored Content</span>
              </div>
            </div>
          </div>
        }
        showLoading={true}
        loadingComponent={
          // Loading state that matches sidebar styling
          <div className="bg-white rounded-2xl p-6 shadow-card animate-pulse">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-200 rounded-full mx-auto mb-4"></div>
              <div className="h-4 bg-gray-200 rounded mb-2"></div>
              <div className="h-3 bg-gray-200 rounded mb-4 w-3/4 mx-auto"></div>
              <div className="space-y-2">
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded"></div>
                <div className="h-3 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        }
        onError={(error) => {
          console.warn('SidebarAd failed:', error);
        }}
        onLoad={() => {
          console.log('SidebarAd loaded successfully');
        }}
        testMode={import.meta.env.DEV} // Show placeholder in development
        adType="sidebar"
      />
    </div>
  );
};

export default SidebarAd;